import { Modal } from "@simplybusiness/mobius";

export type QuoteUnavailableForPurchaseProps = {
  modalOpen: boolean;
  onClose: () => void;
  insurerName: string;
};

export const QuoteUnavailableForPurchase = ({
  modalOpen,
  onClose,
  insurerName,
}: QuoteUnavailableForPurchaseProps) => (
  <Modal
    isOpen={modalOpen}
    onClose={onClose}
    className="mobius-quote-card__modal-container"
    animation="fade"
    closeLabel="Close"
  >
    <Modal.Header>
      Sorry, this policy is only available to purchase during office hours.
    </Modal.Header>
    <Modal.Content>
      Please come back during {insurerName}&apos;s office hours, Mon-Fri 6:30am
      - 11pm (ET) or Sat-Sun 2pm - 8pm (ET) to finalize your purchase. We will
      email you a link shortly.
    </Modal.Content>
  </Modal>
);
